var map = {
	"./avatar-01.jpg": 78941,
	"./avatar-02.jpg": 89144,
	"./avatar-03.jpg": 97980,
	"./avatar-04.jpg": 71357,
	"./avatar-05.jpg": 70489,
	"./avatar-06.jpg": 88893,
	"./avatar-07.jpg": 18367,
	"./avatar-08.jpg": 37159,
	"./avatar-09.jpg": 91014,
	"./avatar-10.jpg": 89269,
	"./avatar-11.jpg": 12162,
	"./avatar-12.jpg": 31493,
	"./avatar-13.jpg": 15741,
	"./avatar-14.jpg": 68538,
	"./avatar-15.jpg": 35676,
	"./avatar-16.jpg": 96756,
	"./avatar-17.jpg": 92267,
	"./avatar-18.jpg": 99751,
	"./avatar-19.jpg": 2073,
	"./avatar-20.jpg": 20883
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90480;